export default "__VITE_ASSET__DDbmoaNE__"